<template dark>
  <div class="renderPage reporte-container animate-fade-in">
    <!-- Main Toolbar -->
    <v-toolbar color="primary" dark flat class="mb-6 rounded-xl" height="64">
      <v-icon class="mr-3" size="28">mdi-lock-check-outline</v-icon>
      <v-toolbar-title class="text-subtitle-1 text-sm-h6 font-weight-black px-0 text-uppercase letter-spacing-1">
        Cerrar Sorteo Manual
      </v-toolbar-title>
      <v-spacer />
      <v-btn icon color="white" to="/home" class="glass-btn">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-container fluid>
      <!-- Glass Card Container -->
      <v-card class="glass-card rounded-xl overflow-hidden mb-6" elevation="0">
        <div class="px-6 py-4 border-bottom header-glass">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-cogs</v-icon>
            <span class="text-subtitle-1 font-weight-bold primary--text">Configuración de Cierre</span>
          </div>
        </div>
        
        <v-card-text class="pa-6">
          <v-row align="center" class="mt-2">
            <v-col cols="12" sm="3" md="3">
              <v-select
                label="Seleccionar Sorteo"
                item-text="descripcion"
                item-value="id"
                v-model="editedItem.idSorteo"
                :items="sorteos"
                @change="changeValueComponent"
                class="modern-input"
                outlined
                dense
                rounded
                hide-details="auto"
              ></v-select>
            </v-col>

            <v-col cols="12" sm="2" md="2">
              <v-text-field
                v-model="editedItem.numero"
                label="Número Ganador"
                @change="changeValueComponent"
                @input="changeValueComponent"
                class="modern-input"
                outlined
                dense
                rounded
                hide-details="auto"
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="3" md="3">
              <v-switch
                v-model="esGlobal"
                label="Cierre Global (Todas las Bancas)"
                color="success"
                hide-details
                class="mt-0"
              ></v-switch>
              <v-switch
                v-if="esGlobal"
                v-model="esReventado"
                label="Cierre Reventados"
                color="error"
                hide-details
                class="mt-2"
              ></v-switch>
            </v-col>

            <v-col cols="12" sm="2" md="2">
              <v-switch
                v-model="esAtrasado"
                label="Cierre Atrasado (Ayer)"
                color="warning"
                hide-details
                class="mt-0"
              ></v-switch>
              
              <v-select
                v-if="esGlobal && esReventado"
                v-model="bolita"
                :items="['BB', 'BR']"
                label="Bolita Reventado"
                class="modern-input mt-2"
                outlined
                dense
                rounded
                hide-details="auto"
                color="error"
              ></v-select>
            </v-col>

            <v-col cols="12" sm="2" md="2" class="text-center text-sm-left mt-4 mt-sm-0">
              <v-btn color="primary" class="rounded-pill px-8 font-weight-bold shadow-soft w-100" height="46" @click="cerrarSorteo()">
                <v-icon left>mdi-checkbox-marked</v-icon>
                Cerrar Sorteo
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
    
    <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
  </div>
</template>
  
  <script>
  import { mapGetters } from "vuex";
  import axios from "axios";
  import Snackbar from "./shared/Snackbar.vue";
  
  export default {
    components: {
      Snackbar,
    },
    dark: true,
    data() {
      return {
        dialog: false,
        snackText: "",
        snackValue: false,
        editedIndex: -1,
        sorteos: [],
        respuestaCerrarSorteo: [],
        esGlobal: false,
        esReventado: false,
        esAtrasado: false,
        bolita: "BB",
        defaultItem: {
          idSorteo: 0,
          numero: 0,
        },
        editedItem: {
          idSorteo: 0,
          numero: 0,
        },
        nameRules: [(v) => !!v || "Campo requerido"],
      };
    },
  
    computed: {
      ...mapGetters(["user", "strCia"]),
    },
  
    watch: {
      dialog(val) {
        val || this.close();
      },
  
      search() {
        this.snackValue = false;
      },
  
      esGlobal(val) {
        if (!val) {
          this.esReventado = false;
        }
      }
    },
  
    created() {
      this.editedItem = Object.assign({}, this.editedItem);
      this.getSorteos();
    },
  
    methods: {
      getSorteos() {
        //this.changeValueComponent();
        let me = this;
        axios
          .get("api/Tiempos/GetSorteosAllv2")
          .then(function (response) {
            me.sorteos = response.data;
            //me.editedItem.idSorteo = me.sorteos[0]["id"];
            //me.getRestringidos();
          })
          .catch(function (error) {
            console.log(error);
          });
      },
  
      cerrarSorteo() {
        this.changeValueComponent();
        this.editedItem.idUsuario = this.user.cedula;
        let me = this;

        if (this.esGlobal && this.esReventado && !this.bolita) {
          me.snackText = "Debe seleccionar la bolita para el cierre de Reventados";
          me.snackValue = true;
          return;
        }

        let currentSorteo = this.sorteos.find(s => s.id === this.editedItem.idSorteo);
        let categoria = currentSorteo ? currentSorteo.categoria : 1;

        let finalIdSorteo = parseInt(this.editedItem.idSorteo);
        if (this.esAtrasado) {
          finalIdSorteo += 500;
        }

        let endpointUrl = "";

        if (this.esGlobal) {
          if (this.esReventado) {
            if (categoria === 2) {
              endpointUrl = `api/Tiempos/CerrarSorteoReventadoNormalPorIdConFechaTodasLasBancas?idSorteo=${finalIdSorteo}&numero=${this.editedItem.numero}&bolita=${this.bolita}`;
            } else {
              endpointUrl = `api/Tiempos/CerrarSorteoReventadoTodoNadaPorIdConFechaTodasLasBancas?idSorteo=${finalIdSorteo}&numero=${this.editedItem.numero}&bolita=${this.bolita}`;
            }
          } else {
            endpointUrl = `api/Tiempos/CerrarSorteosPorIdConFechaTodasLasBancas?idSorteo=${finalIdSorteo}&numero=${this.editedItem.numero}`;
          }
        } else {
          endpointUrl = `api/Tiempos/CerrarSorteosManual?idSorteo=${this.editedItem.idSorteo}&numero=${this.editedItem.numero}`;
          
          if (this.esAtrasado) {
            // Si no es global, el endpoint CerrarSorteosManual no soporta +500. Se redirige al global regular.
            endpointUrl = `api/Tiempos/CerrarSorteosPorIdConFechaTodasLasBancas?idSorteo=${finalIdSorteo}&numero=${this.editedItem.numero}`;
          }
        }

        axios
          .get(endpointUrl)
          .then(function (response) {
            me.respuestaCerrarSorteo = response.data;
            me.snackText = me.respuestaCerrarSorteo;
            me.snackValue = true;
            me.getSorteos();
          })
          .catch(function (error) {
            console.log(error);
            me.snackText = "Ha ocurrido un error inesperado";
            me.snackValue = true;
          });
      },
  
      changeValueComponent() {
        this.snackValue = false;
      },
  
      closed() {
        this.snackValue = false;
        this.showNewData = false;
        this.dialogReport = false;
      },
  
      save() {
        //this.snackValue = false;
        this.editedItem.idUsuario = this.user.cedula;
        let me = this;
  
        if (this.numeros.length < 1) {
          me.snackText = "Por favor seleccione los números a vender";
          me.snackValue = true;
        } else {
          axios
            .post("api/Tiempos/InsertTiquetes", this.editedItem)
            .then(function (response) {
              me.tiqueteInfo.idTiquete = response.data;
              me.snackText =
                "Se ha registrado el tiquete #" +
                response.data +
                " correctamente";
              me.snackValue = true;
              me.editedItem.numeros = "";
              me.editedItem.monto = 0;
              me.editedItem.total = 0;
              me.numeros = [];
              me.restringidos = "";
              me.getTiqueteReport();
              me.getSorteos();
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      },
    },
  };
  </script>
  
  <style scoped>
.reporte-container {
    padding-bottom: 60px;
}

/* Glassmorphism Styles */
.glass-card {
    background: rgba(255, 255, 255, 0.7) !important;
    backdrop-filter: blur(12px) !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.theme--dark .glass-card {
    background: rgba(30, 30, 46, 0.8) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.glass-btn {
    background: rgba(25, 118, 210, 0.1) !important;
}

.header-glass {
    background: rgba(25, 118, 210, 0.03);
}

.theme--dark .header-glass {
    background: rgba(255, 255, 255, 0.02);
}

.border-bottom {
    border-bottom: 1px solid rgba(0,0,0,0.05);
}

.theme--dark .border-bottom {
    border-bottom: 1px solid rgba(255,255,255,0.05);
}

/* Modern Inputs */
.modern-input >>> .v-input__control > .v-input__slot {
    background: rgba(255, 255, 255, 0.5) !important;
    backdrop-filter: blur(4px);
}

.theme--dark .modern-input >>> .v-input__control > .v-input__slot {
    background: rgba(0, 0, 0, 0.2) !important;
}

/* Text Utilities */
.letter-spacing-1 {
    letter-spacing: 1px;
}

/* Animations */
.animate-fade-in {
    animation: fadeIn 0.4s ease-out;
}

.shadow-soft {
    box-shadow: 0 4px 20px rgba(0,0,0,0.08) !important;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

/* Legacy Overrides */
.cd {
  overflow: scroll;
}

.v-tabs-items {
  overflow: auto;
}

.botonSalir {
  position: fixed;
  top: 5px;
  right: 5px;
}

.text-input-blue .v-text-field__slot input {
  color: red !important;
}
</style>